import { backendHttpClient } from "app/utils/axios";
import {
  ZBNI_BACKEND_CLIENT_ID,
  ZBNI_BACKEND_CLIENT_SECRET,
  ZBNI_BACKEND_GRANT_TYPE,
} from "app/config/constants";

export const getAccessToken = async () => {
  const accessToken = await backendHttpClient
    .post("/oauth/token/", {
      client_id: ZBNI_BACKEND_CLIENT_ID,
      client_secret: ZBNI_BACKEND_CLIENT_SECRET,
      grant_type: ZBNI_BACKEND_GRANT_TYPE,
    })
    .then((res) => {
      return res?.data?.access_token;
    });

  return accessToken;
};
